import { useQuery } from '@apollo/client/react';
import {
  GetDatevVerbindungenDocument,
  type GetDatevVerbindungenQuery,
} from '../../../datev-service/gql/graphql';
import { useDatevServiceClient } from '../../../lib/ApolloClient';

export function useDatevVerbindungen(): {
  verbindungen: GetDatevVerbindungenQuery['datevVerbindungen'] | undefined;
  loading: boolean;
} {
  const { data, loading } = useQuery(GetDatevVerbindungenDocument, {
    client: useDatevServiceClient(),
    fetchPolicy: 'cache-and-network',
  });

  return { verbindungen: data?.datevVerbindungen, loading: loading && !data };
}
